import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { log } from 'console';
import { MessageService, SelectItem } from 'primeng/api';
import { RppPatientService } from 'src/app/screens/rpp-patient-list/services/rpp-patient.service';
import * as moment from 'moment';
import { BasicRegistrationService } from 'src/app/screens/hospital-basic-registration/services/basic-registration.service';
import { FileUpload } from 'primeng/fileupload';

interface OffilineAssessmentCatalog {
  assessment_id: number;
  assessment_name: string;
  assessment_shortname: string;
}

@Component({
  selector: 'app-add-offline-assessment',
  templateUrl: './add-offline-assessment.component.html',
  styleUrls: ['./add-offline-assessment.component.scss']
})
export class AddOfflineAssessmentComponent implements OnInit {

  @Input() patientId: number;
  @Input() patientRefId: string;
  @Input() appointmentId: number;
  @Input() assignedTo: number;
  @Input() assignedToName: string;
  @Input() hospId: number;
  @Output() fetchOfflineAssessment  = new EventEmitter<boolean>();

  form: FormGroup;
  addAssessmenCatalogForm: FormGroup;

  offlineAssessmentCatalog: OffilineAssessmentCatalog[] = [];

  assessmentNameOptions: SelectItem[] = [];
  assessmentShortNameOptions: SelectItem[] = [];
  assignedUserList: SelectItem[] = [];
  conductedUserList: SelectItem[] = [];
  recommendedByList: SelectItem[] = [];
  roleList: SelectItem[] = [];

  submitted:boolean = false;

  displayAddNewOfflineAssessment: boolean = false;

  @ViewChild('fileUpload') fileUpload: FileUpload;

  constructor(
    private fb: FormBuilder,
    private rppService: RppPatientService,
    private messageService: MessageService,
    private basicRegService: BasicRegistrationService,
  ) {}

  ngOnInit(): void {
    this.getAssessmentCatalog();
    this.getRoleList();
    this.initForm();
    this.initAddAssessmenCatalogForm();
  }

  initForm() {
    this.form = this.fb.group({
      file: [null, Validators.required],
      assessment_id: ['', Validators.required],
      assessment_name: ['', Validators.required],
      assessment_shortname: ['', Validators.required],
      assessment_date: ['', Validators.required],
      patient_id: ['', Validators.required],
      patient_ref_id: ['', Validators.required],
      appointment_id: ['', Validators.required],
      assigned_to: ['', Validators.required],
      assigned_to_name: ['', Validators.required],
      conducted_by_user_id: ['', Validators.required],
      conducted_by: ['', Validators.required],
      conducted_by_role: ['', Validators.required],
      conducted_by_role_id: ['', Validators.required],
      recommended_by_user_id: ['', Validators.required],
      recommended_by: ['', Validators.required],
      recommended_by_role_id: ['', Validators.required],
      recommended_by_role: ['', Validators.required],
      hosp_id: ['', Validators.required]
    });
    this.form.patchValue({ 
      patient_id: this.patientId,
      patient_ref_id: this.patientRefId,
      appointment_id: this.appointmentId,
      assigned_to: this.assignedTo,
      assigned_to_name: this.assignedToName,
      hosp_id: this.hospId
    });
  }

  initAddAssessmenCatalogForm() {
    this.addAssessmenCatalogForm = this.fb.group({
      assessment_name: ['', Validators.required],
      assessment_shortname: ['', Validators.required]
    });
  }

  getAssessmentCatalog() {
    this.rppService.getOfflineAssessmentCatalog().subscribe((res: any) => {
      if(res.success) {
       this.offlineAssessmentCatalog = res.data;
        this.assessmentNameOptions = this.offlineAssessmentCatalog.map((item): SelectItem => ({ label: item.assessment_name, value: item.assessment_id }));
        this.assessmentShortNameOptions = this.offlineAssessmentCatalog.map((item): SelectItem => ({ label: item.assessment_shortname, value: item.assessment_id }));
      }
    });
  }

  onAssessmentNameChange() {
    const selectedAssessmentName = this.form.get('assessment_name')?.value;
    const selectedAssessment = this.offlineAssessmentCatalog.find(item => item.assessment_name === selectedAssessmentName);
    if (selectedAssessment) {
      this.form.patchValue({ 
        assessment_shortname: selectedAssessment.assessment_shortname,
        assessment_id: selectedAssessment.assessment_id
      });
    }
    
  }

  onAssessmentShortNameChange() {
    const selectedAssessmentShortName = this.form.get('assessment_shortname')?.value;
    const selectedAssessment = this.offlineAssessmentCatalog.find(item => item.assessment_shortname === selectedAssessmentShortName);
    if (selectedAssessment) {
      this.form.patchValue({ 
        assessment_name: selectedAssessment.assessment_name,
        assessment_id: selectedAssessment.assessment_id
      });
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.form.valid) {
      // const date = moment(this.form.get('assessment_date')?.value).format('YYYY-MM-DD');
      // this.form.patchValue({ assessment_date: date });
      
      const formData = new FormData();
      Object.keys(this.form.value).forEach(key => {
        formData.append(key, this.form.value[key]);
      });
      this.rppService.savePatientOfflineAssessment(formData).subscribe((res: any) => {
        console.log(res);
        if (res.success) {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Offline accessment record saved successfully' });
          this.submitted = false;
          this.fetchOfflineAssessment.emit(true);
          this.form.reset();
          // Clear file input
          this.fileUpload.clear();
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error in saving assessment' });
          this.submitted = false;
        }
      });
      
    } else {
      console.log('Form is invalid');
      // loop through the form and tell the invalid field
      Object.keys(this.form.controls).forEach(key => {
        if (this.form.controls[key].invalid) {
          console.log(key, this.form.controls[key].errors);
        }
      });
    }
  }

  onFileSelect(event: any) {
    const file = event[0];
    this.form.patchValue({ file });
    this.form.get('file')?.updateValueAndValidity();
  }

  getRoleList() {
    this.basicRegService.getRoleslist().subscribe(
      (res: any) => {
        if (res) {
          this.roleList = res.map((item): SelectItem => ({ label: item.role_name, value: item.role_id }));
        }
      }
    )
  }

  getUserList(type: string) {
    let formdata: any;
    formdata = this.form.getRawValue();
    let payload: any;
    if(type === 'conducted') {
      payload = {
        role_id: formdata.conducted_by_role_id
      }
    } else if(type === 'recommended') {
      payload = {
        role_id: formdata.recommended_by_role_id
      }
    } else {
      payload = {
        role_id: ''
      }
    }

    this.basicRegService.getUserbyRole(payload).subscribe((res: any) => {
      if (res) {
        if (type === 'conducted') {
          this.conductedUserList = res.map((item): SelectItem => ({ label: item.display_name, value: item.user_id }));
        } else if (type === 'recommended') {
          this.recommendedByList = res.map((item): SelectItem => ({ label: item.display_name, value: item.user_id }));
        }
      }
    });
  }

  onConductedByChange(event) {
    const conductedById = event;
    const conductedBy = this.conductedUserList.find(item => item.value === conductedById);
    const conductedByRole = this.roleList.find(item => item.value === this.form.get('conducted_by_role_id')?.value);
    if (conductedBy) {
      this.form.patchValue({ 
        conducted_by: conductedBy.label,
        conducted_by_role: conductedByRole.label
      });
    }
  }

  onRecommendedByChange(event) {
    const recommendedById = event;
    const recommendedBy = this.recommendedByList.find(item => item.value === recommendedById);
    const recommendedByRole = this.roleList.find(item => item.value === this.form.get('recommended_by_role_id')?.value);
    if (recommendedBy) {
      this.form.patchValue({ 
        recommended_by: recommendedBy.label,
        recommended_by_role: recommendedByRole.label
      });
    }
  }

  addNewOfflineAssessment() {
    this.displayAddNewOfflineAssessment = true;
  }

  submitted1:boolean = false;
  onSubmitSaveAssessmentCatalog() {
    this.submitted1 = true;
    if (this.addAssessmenCatalogForm.valid) {
      this.rppService.saveOfflineAssessment(this.addAssessmenCatalogForm.value).subscribe((res: any) => {
        if (res.success) {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Offline accessment catalog saved successfully' });
          this.submitted1 = false;
          this.displayAddNewOfflineAssessment = false;
          this.getAssessmentCatalog();
          this.addAssessmenCatalogForm.reset();
          // Reload page
          window.location.reload();
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error in saving assessment catalog' });
          this.submitted1 = false;
        }
      });
      
    } else {
      console.log('Form is invalid');
      // loop through the form and tell the invalid field
      Object.keys(this.addAssessmenCatalogForm.controls).forEach(key => {
        if (this.addAssessmenCatalogForm.controls[key].invalid) {
          console.log(key, this.addAssessmenCatalogForm.controls[key].errors);
        }
      });
    }
  }
  

}
